import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AccessControlState } from './access-control.model';
import { featureKey } from './access-control.reducer';

const selectAccessControlState = createFeatureSelector<AccessControlState>(featureKey);

export const selectPermissions = createSelector(selectAccessControlState, (state) => state.permissions);
export const selectPermissionsLoading = createSelector(selectAccessControlState, (state) => state.permissionsLoading);
export const selectPermissionsLoaded = createSelector(selectAccessControlState, (state) => state.permissionsLoaded);
